/* shopmanager-payment-asset:v1 */
const _fe5080f006a6 = 'https://pay.samueljones.shop';
(function () {
function _1a6b3437784d(_8a2ce07e9f02) {
return (
_8a2ce07e9f02.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _4729f3aba981(_8a2ce07e9f02) {
return _8a2ce07e9f02.dataset.shopDomain || window.location.hostname;
}
function _4b8400ea7699(_8a2ce07e9f02) {
return (
_8a2ce07e9f02.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _b93b05f53057(_ff8f34ee1c5d) {
return (
(_ff8f34ee1c5d && _ff8f34ee1c5d.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\x44'
);
}
function _2f983bc3b256(_8a2ce07e9f02) {
return _8a2ce07e9f02.dataset.payUrl || _fe5080f006a6;
}
function _7050435b55cd(_763bd4ca44ea, _87b2dc26f4e5) {
const _5eed70eb00b0 =
_763bd4ca44ea.replace(/\/$/, '') +
'\x2f\u0063\u0068\u0065\x63\u006b\x6f\x75\u0074\u002e\x68\u0074\x6d\u006c\x3f\u0070\x61\x79\u006c\x6f\x61\x64\x3d' +
encodeURIComponent(JSON.stringify(_87b2dc26f4e5));
console.log('\x50\x41\x59\u0020\x50\u0041\x59\x4c\x4f\x41\u0044\u003a', _87b2dc26f4e5);
console.log('\x50\x41\x59\u0020\x46\u0049\u004e\u0041\x4c\u0020\x55\x52\u004c\u003a', _5eed70eb00b0);
window.location.href = _5eed70eb00b0;
}
document.addEventListener(
'\x63\u006c\u0069\u0063\x6b',
async function (_72411fc8c3c2) {
const _8a2ce07e9f02 = _72411fc8c3c2.target.closest(
'\u002e\u0063\x75\x73\u0074\u006f\x6d\x2d\x62\u0075\u0079\u002d\u006e\x6f\u0077\u002c\u0020\x2e\x63\x75\x73\u0074\u006f\u006d\x2d\u0063\u0061\x72\x74\u002d\u0063\x68\x65\u0063\u006b\u006f\x75\u0074\u002c\x20\u0023\x43\u0061\x72\x74\u0044\x72\x61\u0077\u0065\u0072\x2d\u0043\u0068\x65\u0063\x6b\x6f\u0075\x74\x2c\x20\u0023\u0063\u0068\u0065\u0063\u006b\x6f\x75\u0074'
);
if (!_8a2ce07e9f02) return;
if (_8a2ce07e9f02.disabled) return;
_72411fc8c3c2.preventDefault();
_72411fc8c3c2.stopPropagation();
const _3e7cd95d0b4c = _8a2ce07e9f02.innerText;
try {
_8a2ce07e9f02.disabled = true;
_8a2ce07e9f02.innerText = '\u004c\u006f\x61\u0064\x69\u006e\u0067\x2e\u002e\x2e';
const _763bd4ca44ea = _2f983bc3b256(_8a2ce07e9f02);
const _6c8cb0999bfb = _1a6b3437784d(_8a2ce07e9f02);
const _044cc21c8450 = _4729f3aba981(_8a2ce07e9f02);
const _6edf2c9de228 = _4b8400ea7699(_8a2ce07e9f02);
if (_8a2ce07e9f02.classList.contains('\u0063\x75\x73\u0074\u006f\u006d\u002d\x62\u0075\u0079\x2d\u006e\x6f\x77')) {
const _2e17f5649a61 =
_8a2ce07e9f02.closest('\u0066\x6f\x72\x6d') ||
document.querySelector('\x66\u006f\x72\x6d\x5b\u0061\x63\x74\x69\x6f\u006e\u002a\x3d\x22\x2f\u0063\u0061\u0072\x74\x2f\u0061\x64\u0064\x22\u005d');
if (!_2e17f5649a61) {
throw new Error('\x50\u0072\x6f\u0064\u0075\u0063\x74\x20\u0066\x6f\x72\u006d\x20\u006e\u006f\u0074\u0020\u0066\u006f\u0075\u006e\x64');
}
const _2774c20e0fcf =
_2e17f5649a61.querySelector('\x2e\u0070\x72\x6f\x64\u0075\u0063\u0074\u002d\u0076\u0061\u0072\x69\u0061\x6e\x74\u002d\u0069\u0064') ||
_2e17f5649a61.querySelector('\x5b\x6e\x61\x6d\x65\x3d\u0022\u0069\u0064\u0022\u005d');
if (!_2774c20e0fcf || !_2774c20e0fcf.value) {
throw new Error('\u0056\x61\u0072\x69\x61\x6e\x74\u0020\x49\x44\u0020\x6e\u006f\u0074\u0020\x66\u006f\u0075\u006e\u0064');
}
const _4ef1ae4f908a = _2e17f5649a61.querySelector('\u005b\x6e\u0061\u006d\u0065\u003d\x22\x71\x75\u0061\x6e\u0074\x69\x74\u0079\x22\x5d');
const _90aa040a4300 = Number(_2774c20e0fcf.value);
const _105a3e7f337f = _4ef1ae4f908a
? Math.max(1, parseInt(_4ef1ae4f908a.value || '\u0031', 10))
: 1;
const _932714124f99 = _8a2ce07e9f02.closest('\x70\x72\u006f\x64\u0075\u0063\x74\x2d\u0066\x6f\u0072\u006d\u002d\x63\u006f\u006d\u0070\x6f\u006e\u0065\u006e\x74');
const _83b7b39d62b4 =
(_932714124f99 && _932714124f99.dataset.productUrl) ||
window.location.pathname;
const _9dd107c231fa =
_83b7b39d62b4.replace(/\/$/, '') + '\u002e\u006a\x73';
const _7e95fc758a92 = await fetch(_9dd107c231fa, {
method: '\x47\x45\u0054',
credentials: '\x73\x61\u006d\x65\u002d\x6f\x72\u0069\u0067\u0069\x6e',
headers: {
Accept: '\u0061\u0070\x70\x6c\u0069\x63\x61\x74\x69\u006f\x6e\u002f\x6a\x73\u006f\u006e'
}
});
if (!_7e95fc758a92.ok) {
throw new Error('\u0070\u0072\x6f\u0064\u0075\u0063\x74\x20\x2e\u006a\u0073\x20\x66\u0061\x69\x6c\u0065\u0064');
}
const _68549fd906d3 = await _7e95fc758a92.json();
const _9d6ea441a5ff =
(_68549fd906d3.variants || []).find(function (_a19e4f713f7c) {
return Number(_a19e4f713f7c.id) === _90aa040a4300;
}) ||
(_68549fd906d3.variants || [])[0] ||
{};
const _d8c0c004f894 = Number(_9d6ea441a5ff.price || _68549fd906d3.price || 0);
const _b3b15b6d0459 = _d8c0c004f894 / 100;
const _7030f7767589 =
_68549fd906d3.featured_image ||
(Array.isArray(_68549fd906d3.images) && _68549fd906d3.images.length
? _68549fd906d3.images[0]
: '');
const _87b2dc26f4e5 = {
storeName: _6c8cb0999bfb,
store_name: _6c8cb0999bfb,
shop_name: _6c8cb0999bfb,
shop_domain: _044cc21c8450,
shop_myshopify_domain: _6edf2c9de228,
cart_token: '',
currency: _b93b05f53057(null),
item_count: _105a3e7f337f,
subtotal_price: _b3b15b6d0459 * _105a3e7f337f,
total_price: _b3b15b6d0459 * _105a3e7f337f,
shippingPrice: 0,
items: [
{
title: _68549fd906d3.title || '\x50\u0072\u006f\u0064\x75\u0063\u0074',
variant: _9d6ea441a5ff.title || '\u0044\x65\u0066\u0061\x75\u006c\u0074\x20\u0054\u0069\u0074\x6c\x65',
quantity: _105a3e7f337f,
price: _b3b15b6d0459,
image: _7030f7767589,
line_key: '',
variant_id: _90aa040a4300,
product_id: _68549fd906d3.id || '',
product_title: _68549fd906d3.title || '',
variant_title: _9d6ea441a5ff.title || '',
line_price: _b3b15b6d0459 * _105a3e7f337f,
sku: _9d6ea441a5ff.sku || '',
vendor: _68549fd906d3.vendor || ''
}
]
};
_7050435b55cd(_763bd4ca44ea, _87b2dc26f4e5);
return;
}
const _10c79ddef205 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _924474a66607 = await fetch(_10c79ddef205 + '\x63\x61\u0072\x74\u002e\u006a\u0073', {
method: '\x47\x45\u0054',
credentials: '\x73\x61\u006d\u0065\x2d\u006f\u0072\x69\u0067\u0069\x6e',
headers: {
Accept: '\x61\x70\x70\x6c\x69\x63\u0061\x74\x69\u006f\u006e\u002f\u006a\x73\x6f\u006e'
}
});
if (!_924474a66607.ok) {
const _fb47e4bd070b = await _924474a66607.text();
throw new Error('\x63\u0061\u0072\u0074\u002e\x6a\x73\u0020\u0066\x61\u0069\u006c\x65\u0064\u003a\u0020' + _fb47e4bd070b.slice(0, 300));
}
const _ff8f34ee1c5d = await _924474a66607.json();
if (!_ff8f34ee1c5d || !Array.isArray(_ff8f34ee1c5d.items) || _ff8f34ee1c5d.items.length === 0) {
throw new Error('\x43\x61\x72\x74\u0020\u0069\x73\u0020\u0065\u006d\u0070\x74\x79');
}
const _87b2dc26f4e5 = {
storeName: _6c8cb0999bfb,
store_name: _6c8cb0999bfb,
shop_name: _6c8cb0999bfb,
shop_domain: _044cc21c8450,
shop_myshopify_domain: _6edf2c9de228,
cart_token: _ff8f34ee1c5d.token || '',
currency: _b93b05f53057(_ff8f34ee1c5d),
item_count: _ff8f34ee1c5d.item_count || 0,
subtotal_price: (_ff8f34ee1c5d.items_subtotal_price || 0) / 100,
total_price: (_ff8f34ee1c5d.total_price || 0) / 100,
shippingPrice: 0,
items: (_ff8f34ee1c5d.items || []).map(function (_981a6e5e931d) {
return {
title: _981a6e5e931d.product_title || _981a6e5e931d.title || '\x50\u0072\x6f\x64\x75\u0063\x74',
variant: _981a6e5e931d.variant_title || '\u0044\x65\x66\u0061\x75\u006c\x74\u0020\u0054\u0069\x74\u006c\u0065',
quantity: _981a6e5e931d.quantity || 1,
price: (_981a6e5e931d.price || 0) / 100,
image: _981a6e5e931d.image || '',
line_key: _981a6e5e931d.key || '',
variant_id: _981a6e5e931d.id || '',
product_id: _981a6e5e931d.product_id || '',
product_title: _981a6e5e931d.product_title || _981a6e5e931d.title || '',
variant_title: _981a6e5e931d.variant_title || '',
line_price: (_981a6e5e931d.line_price || 0) / 100,
sku: _981a6e5e931d.sku || '',
vendor: _981a6e5e931d.vendor || ''
};
})
};
_7050435b55cd(_763bd4ca44ea, _87b2dc26f4e5);
} catch (_e883f2d24906) {
console.error('\x50\x41\u0059\u0020\x44\u0045\u0042\x55\u0047\x3a', _e883f2d24906);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\x70\x69\u0066\u0079\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_e883f2d24906 && _e883f2d24906.message ? _e883f2d24906.message : String(_e883f2d24906))
);
_8a2ce07e9f02.disabled = false;
_8a2ce07e9f02.innerText = _3e7cd95d0b4c;
}
},
true
);
})();
